import { api } from "../api";
import { VehicleDriverChangeType } from "../../../types/types";

const findVehicleDriverChanges = (
    token: string,
    vehicleId: number,
    customerId: number,
    departmentId: number,
    ignoreDepartments: boolean = false,
    signal?: AbortSignal
) => api.get<VehicleDriverChangeType[]>(`/vehicles/${vehicleId}/driver-changes`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { customerId, departmentId, ignoreDepartments },
    signal,
    timeout: 10000,
});

export default findVehicleDriverChanges;
